import { render } from "./ReportPost.vue?vue&type=template&id=8d8df1aa&ts=true"
import script from "./ReportPost.vue?vue&type=script&lang=ts"
export * from "./ReportPost.vue?vue&type=script&lang=ts"

import "./ReportPost.vue?vue&type=style&index=0&id=8d8df1aa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard});
